import {
  collection,
  getDocs,
  limit,
  query,
  Timestamp,
  where,
} from "firebase/firestore";

import { db } from "@/lib/firebase";
import type { ListingEntitlement } from "@/types/listingEntitlement";

export async function getActiveEntitlement(
  ownerId: string
): Promise<ListingEntitlement | null> {
  if (!ownerId) {
    return null;
  }

  const now = Timestamp.now();

  const q = query(
    collection(db, "listingEntitlements"),
    where("ownerId", "==", ownerId),
    where("status", "==", "active"),
    where("endsAt", ">", now),
    limit(1)
  );

  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return null;
  }

  const docSnap = snapshot.docs[0];

  return {
    id: docSnap.id,
    ...(docSnap.data() as Omit<ListingEntitlement, "id">),
  };
}